import React, { useState } from "react"
import Offcanvas from 'react-bootstrap/Offcanvas'
import Button from 'react-bootstrap/Button'
import CloseButton from 'react-bootstrap/CloseButton'
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import { FaUsers, FaExclamationTriangle, FaShieldAlt, FaVideo } from 'react-icons/fa'

import XAccess from "../components/XAccess";
import XMembers from "../components/XMembers";
import XDocz from "../components/XDocz";
import IncidentZ from "../components/Incidentz";
import XMenu from '../components/XMenu';
import XReportz from "../components/XReportz"
import XAdminReports from "../components/XAdminReports";
import gear from "../images/gear.png"
import AdminSite from "../components/AdminSite"
import XRSVPList from "../components/XRSVPList"
import EventSuite from '../components/EventSuite';
import VideoAdminConsole from "../components/VideoAdminConsole";
import BannedListAdmin from "../components/BannedListAdmin";
import AccessReports from "../components/AccessReports";

export default function Admin(props) {
    const [showCanvas, setShowCanvas] = useState(false);

    // Track which child panel is active within the main Admin area
    const [activeChild, setActiveChild] = useState(null);

    // Top-level tab state
    const [activeTab, setActiveTab] = useState("support");

    const handleCloseCanvas = () => {
        setShowCanvas(false);
        setActiveChild(null); // Clear open children when main panel closes
    };

    const handleShowCanvas = () => setShowCanvas(true);

    const [isAdminOpen, setIsAdminOpen] = useState(false);

    // Toggle logic helper for child items
    const toggleChildView = (viewName) => {
        setActiveChild(prev => prev === viewName ? null : viewName);
    };

    // Safe tab change handler that triggers the video console automatically on the votes tab
    const handleTabSelect = (tabKey) => {
        setActiveTab(tabKey);
        if (tabKey === 'votes') {
            setActiveChild('videoConsole'); // Auto-opens the console on select
        } else {
            setActiveChild(null); // Resets panel closures for other tabs
        }
    };

    return (
        <>
            <Button onClick={() => setShowCanvas(true)}>
                <img
                    src={gear}
                    alt="Admin"
                    className="thumb hoverX animated fadeInRight"
                />  <br></br>
                <span>Admin</span>
            </Button>

            <Offcanvas show={showCanvas} onHide={handleCloseCanvas} backdropClassName="adminBackdrop" placement="top" className="bg-dark" >
                <Offcanvas.Header className="pb-2 border-bottom border-opacity-10">
                    <div className="w-100">
                        {/* Title Row */}
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className="modified xTitle animated rollIn m-0">
                                Admin
                            </h3>
                            <CloseButton
                                variant="white"
                                onClick={handleCloseCanvas}
                                className="m-0 p-1"
                            />
                        </div>

                        {/* RESPONSIVE BREAKPOINT TABS */}
                        <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                            <Nav
                                variant="pills"
                                className="flex-column flex-sm-row gap-2 mb-1 profile-nav-dark"
                            >
                                <Nav.Item className="flex-fill">
                                    <Nav.Link eventKey="support" className="text-center py-2 d-flex align-items-center justify-content-center gap-2">
                                        <FaUsers size={14} /> Support
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="flex-fill">
                                    <Nav.Link eventKey="reports" className="text-center py-2 d-flex align-items-center justify-content-center gap-2">
                                        <FaExclamationTriangle size={14} /> Reports
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="flex-fill">
                                    <Nav.Link eventKey="votes" className="text-center py-2 d-flex align-items-center justify-content-center gap-2">
                                        <FaVideo size={14} /> Votes
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="flex-fill">
                                    <Nav.Link eventKey="banned" className="text-center py-2 d-flex align-items-center justify-content-center gap-2">
                                        <FaShieldAlt size={14} /> Banned List
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Tab.Container>
                    </div>
                </Offcanvas.Header>

                <Offcanvas.Body className="padding squiggleX">
                    <Tab.Container activeKey={activeTab}>
                        <Tab.Content>

                            {/* --- SUPPORT TAB CONTENT --- */}
                            <Tab.Pane eventKey="support">
                              
                                <div className="">
                                    <div className="admin-grid-container">
                                        <div className="glass-tile">
                                            <XAccess
                                                isOpen={activeChild === 'access'}
                                                onToggle={() => toggleChildView('access')}
                                            />
                                        </div>
                                        <div className="glass-tile">
                                            <XDocz
                                                public={false}
                                                isOpen={activeChild === 'docz'}
                                                onToggle={() => toggleChildView('docz')}
                                            />
                                        </div>
                                        <div className="glass-tile">
                                            <AdminSite
                                                isOpen={activeChild === 'site'}
                                                onToggle={() => toggleChildView('site')}
                                            />
                                        </div>
                                        <div className="glass-tile">
                                            <XMenu
                                                public={false}
                                                isOpen={activeChild === 'menu'}
                                                onToggle={() => toggleChildView('menu')}
                                            />
                                        </div>
                                        <div className="glass-tile">
                                            <XRSVPList
                                                isOpen={activeChild === 'rsvp'}
                                                onToggle={() => toggleChildView('rsvp')}
                                            />
                                        </div>
                                        <div className="glass-tile">
                                            <EventSuite
                                                theme="dark"
                                                currentUser={localStorage.getItem('email')}
                                                isAdmin={true}
                                                isOpen={activeChild === 'events'}
                                                onToggle={() => toggleChildView('events')}
                                            />
                                        </div>
                                        <div className="glass-tile">
                                            <IncidentZ
                                                isOpen={activeChild === 'incidents'}
                                                onToggle={() => toggleChildView('incidents')}
                                            />
                                        </div>
                                        <div className="glass-tile">
                                            <XMembers
                                                theme={"dark"}
                                                isOpen={activeChild === 'members'}
                                                onToggle={() => toggleChildView('members')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>

                            {/* --- REPORTS TAB CONTENT --- */}
                            <Tab.Pane eventKey="reports">
                             
                                <div>
                                    <div className="admin-grid-container">
                                        <div className="glass-tile">
                                            <XAdminReports
                                                isOpen={activeChild === 'adminReports'}
                                                onToggle={() => toggleChildView('adminReports')}
                                            />
                                        </div>
                                        <div className="glass-tile">
                                            <AccessReports
                                            className="glass-tile"
                                                isOpen={activeChild === 'accessReports'}
                                                onToggle={() => toggleChildView('accessReports')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>

                            {/* --- VOTES TAB CONTENT --- */}
                            <Tab.Pane eventKey="votes">
                                <strong>Voting or Video Streaming</strong><br></br><br></br>

                                {/* Placeholder for instructions or custom text */}
                                <div className="mb-3 text-white-50 small arrow_box_top">
                                    <p>Use the console interface below to manage ongoing streams, voting protocols, and configuration parameters.</p>
                                </div>


                                <VideoAdminConsole
                                    isOpen={activeChild === 'videoConsole'}
                                    onClose={() => toggleChildView('videoConsole')}
                                />

                            </Tab.Pane>

                            {/* --- BANNED LIST TAB CONTENT --- */}
                            <Tab.Pane eventKey="banned">
                                <strong>Global Banned List</strong><br></br><br></br>
                                <div className="arrow_box_top">
                                    <BannedListAdmin
                                        isOpen={activeChild === 'bannedList'}
                                        onToggle={() => toggleChildView('bannedList')}
                                    />
                                    <div></div>
                                </div>
                            </Tab.Pane>

                        </Tab.Content>
                    </Tab.Container>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}